import Image from 'next/image';
import Text from '../Typography/Text';
import { media } from '../../styles/media';
import styled from 'styled-components';

export const WrapperAudioPlayer = styled.div`
  margin: 0 58px ${props => props.theme.layout.gutter * 2}px;
`;

export const TitleContent = styled.div`
  margin-bottom: 10px;
`;

export const WrapperSlider = styled.div``;

export const SlideWrapper = styled.div`
  height: 278px;
`;

export const ImageWrapper = styled.div``;

export const ImageWrapperSingle = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const SlideTitleWrapper = styled.div`
  margin-top: 20px;
`;
